import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { BOOKING_URL, SITE } from '../../data/site';
export function MobileActionBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-white/10 bg-ink pb-[env(safe-area-inset-bottom)] md:hidden" data-id="element-411" data-mp="1gsdg5hty47m9">
      <a href={SITE.phoneHref} className="flex h-14 items-center justify-center gap-2 font-display text-sm font-semibold uppercase tracking-wider text-white" data-id="element-412" data-mp="172aeyuco7ncu">
        <PhoneIcon className="h-4 w-4 text-accent-bright" aria-hidden="true" data-id="element-413" data-mp="120l176y2cvl2" />
        Call
      </a>
      <a href={BOOKING_URL} className="flex h-14 items-center justify-center bg-accent font-display text-sm font-semibold uppercase tracking-wider text-white" data-id="element-414" data-mp="y36upn1rp1wr">
        Book a Class
      </a>
    </div>;
}